import { defineAction } from '~/prix'
import { z } from 'zod'
import operatorCreateAction from './operatorCreate.action.json' with { type: 'json' }
import { operatorCreateInputObject } from '../operatorObject'

const operatorCreateDefinition = defineAction({
  ...operatorCreateAction,

  input: operatorCreateInputObject,
  output: z.object({
    id: z.string().uuid(),
    code: z.number().int().positive(),
  }),
})

export default operatorCreateDefinition
